import React from 'react'
import { observer } from 'mobx-react'
import { useToggle } from 'hooks/state-hooks'
import FilterControls from 'infra/FilterControls'
import PrimaryControls from './PrimaryControls'
import { DocumentManagementViewModel } from '../DocumentManagementViewModel'
import styles from './DocumentManagementFilterViewer.sass'

interface DocumentManagementFilterViewerProps {
  vm: DocumentManagementViewModel
}

export default observer(function DocumentManagementFilterViewer({
  vm,
}: DocumentManagementFilterViewerProps) {
  const hasFilters = vm.searcher.filters.appliedFilterCount > 0
  const showingFilterControls = useToggle(hasFilters)

  return (
    <div className={styles.documentManagementFilterViewer}>
      <PrimaryControls
        vm={vm}
        onChange={vm.searcher.searchText.change}
        onShowFilterControlsClick={showingFilterControls.toggle}
        filterCount={vm.searcher.filters.appliedFilterCount}
        value={vm.searcher.searchText.value}
      />
      <FilterControls
        active={showingFilterControls.isEnabled}
        vm={vm.searcher.filters}
        dataTestSubject="document"
      />
    </div>
  )
})
